import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface CollectionsListingCSVRequest {
  token: string;
  externalAccount: string;
  totalRowCount: number;
  startDate?: string;
  endDate?: string;
}

const downloadCollectionsListingCSV = async ({
  token,
  externalAccount,
  totalRowCount,
  startDate,
  endDate,
}: CollectionsListingCSVRequest) => {
  let url = `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/downloadCollectionsListingCSV`;

  try {
    const requestBody: any = {
      onBehalfOfAccount: externalAccount,
      pagination: {
        page: 1,
        perPage: totalRowCount,
      },
    };

    if (startDate) {
      requestBody.startDate = startDate;
    }

    if (endDate) {
      requestBody.endDate = endDate;
    }

    const response = await axios.post(url, requestBody, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadCollectionsListingCSV;
